import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CircularProgress,
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { providerApi } from '../../services/api';

const InfluencerStats = ({ providerData }) => {
  const { t } = useTranslation();
  const [referralCount, setReferralCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferralCount = async () => {
      try {
        const data = await providerApi.getReferralCount();
        setReferralCount(data.count || 0);
        setLoading(false);
      } catch (err) {
        // If endpoint doesn't exist yet, use mock data
        setReferralCount(0);
        setLoading(false);
      }
    };

    fetchReferralCount();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card sx={{ borderRadius: 2 }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {t('influencer.title')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('influencer.subtitle')}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card 
          sx={{ 
            borderRadius: 2,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <PeopleIcon sx={{ fontSize: 40, mr: 2 }} />
              <Box>
                <Typography variant="h3" fontWeight="bold">
                  {referralCount}
                </Typography>
                <Typography variant="body2">
                  {t('influencer.totalReferrals')}
                </Typography>
              </Box>
            </Box>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {t('influencer.referralsCaption')}
            </Typography>
          </CardContent>
        </Card>
      </Grid>


      <Grid item xs={12}>
        <Card sx={{ borderRadius: 2 }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {t('influencer.tipsTitle')}
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {t('influencer.tip1')}
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {t('influencer.tip2')}
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {t('influencer.tip3')}
              </Typography>
              <Typography component="li" variant="body2" color="text.secondary">
                {t('influencer.tip4')}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default InfluencerStats;
